const convertToMasterAreaState = (data: any[]) => {
    const objectFormAll: any[] = [];
    const resultData: any[] = data?.map((e1: any) => {
        const children = e1.children?.map((e2: any) => {
            if (e2.children) {
                const children = e2.children?.map((e3: any) => {
                    const code3 = `.${e1.companyCd}.${e2.lineCd}.${e3.id}`;

                    objectFormAll.push(code3);
                    return {
                        id: e3.id,
                        code: code3,
                        name: e3?.stationName ?? '',
                        numberProperty: e3?.numberProperty ?? 0,
                        level: 2,
                        parentCode: `.${e1.companyCd}.${e2.lineCd}`,
                    };
                });
                const code2 = `.${e1.companyCd}.${e2.lineCd}`;
                objectFormAll.push(code2);
                return {
                    id: e2.lineCd,
                    code: code2,
                    name: e2?.lineName ?? '',
                    numberProperty: e2?.numberProperty ?? 0,
                    level: 1,
                    children,
                    parentCode: `.${e1.companyCd}`,
                };
            }
        });

        const code1 = `.${e1.companyCd}`;
        objectFormAll.push(code1);
        return {
            id: e1.companyCd,
            code: code1,
            name: e1?.companyName ?? '',
            numberProperty: e1?.numberProperty ?? 0,
            level: 0,
            children,
            parentCode: '',
        };
    });
    return {
        objectFormAll,
        resultData,
    };
};

export { convertToMasterAreaState };
